import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeCreateLegalGuardianAttestationMutation as useDeCreateLegalGuardianAttestationMutationType } from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeCreateLegalGuardianAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeCreateLegalGuardianAttestationMutation($input: De_createAttestationGuardianInput!) {
    de_createAttestationGuardian(input: $input) {
      de_AttestationGuardian {
        id
        ...deLegalGuardianAttestationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeCreateLegalGuardianAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeCreateLegalGuardianAttestationMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreateLegalGuardianAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreateLegalGuardianAttestationMutation }
